import * as XLSX from 'xlsx';
import clsx from 'clsx';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import defaultImg from 'src/assets/images/defaultImg.svg';
import { commonVaribles, excludeDownload } from './constVariables';
import {
	Regex,
	dateColumns,
	downloadExcelHeaderNameForTrolleyMaster,
} from './constant';

import globalstyle from 'src/assets/scss/global.module.scss';
import moment from 'moment-timezone';
import { onResponse } from 'src/redux/features';
import { store } from 'src/redux';
import { isPlainObject } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

export const currentDate = new Date();
export const oneMonthAgo = new Date();
oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

export const formatDate = (date) => {
	return moment(date).format('DD/MM/YYYY');
};

export const formatDateInYMD = (date) => {
	const istMoment = moment.utc(date).tz('Asia/Kolkata');
	return istMoment.format('YYYY-MM-DD');
}

export const convertUTCtoISTInYMD = (date) => {
	const istMoment = moment.utc(date).tz('Asia/Kolkata');
	return istMoment.format('YYYY-MM-DD[T]HH:mm:ss');	
}

export const convertISTtoUTC = (istDate) => {
	const utcMoment = moment(istDate).utc().format('YYYY-MM-DDTHH:mm:ssZ');
	return utcMoment;
};

export const conversionToCrore = (value) => {
	if (value && typeof value != 'int') {
		value = parseInt(value);
	}
	if (!value) {
		return 0;
	}
	return (value / 10000000).toFixed(3);
};

export const convertUTCtoIST = (utcDate) => {
	const istMoment = moment.utc(utcDate).tz('Asia/Kolkata');
	return istMoment.format('YYYY-MM-DD HH:mm:ss');
};

export const refresh = () => window.location.reload(true);

export const isObjectEmpty = (object) => {
	return Object.keys(object).length === 0;
};

function reorderKeysInArrayOfObjects(arr, keyOrder) {
	let temp_obj = {};
	let master_obj = [];

	arr.forEach((temp) => {
		temp_obj = {};
		keyOrder.forEach((orderKey) => {
			temp_obj[orderKey] = temp[orderKey];
		});
		master_obj.push(temp_obj);
	});
	return master_obj;
}

export function downloadBulk(data, name) {
	const excludeDownloadHeading = [
		{ name: 'Trolly_list', value: 'TROLLEY LIST' },
	];

	var Heading = [[]];
	Object.keys(data[0]).map((header, index) => {
		var a = excludeDownloadHeading.filter((o) => o.name === header);
		if (a.length) {
			Heading[0].push(a[0].value);
		} else {
			Heading[0].push(
				header.replace(/_+/g, ' ').replace('fk', '').toUpperCase()
			);
		}
	});
	var today = new Date();
	var date =
		String(today.getFullYear()).padStart(2, '0') +
		'-' +
		String(today.getMonth() + 1).padStart(2, '0') +
		'-' +
		String(today.getDate()).padStart(2, '0') +
		'_' +
		String(today.getHours()).padStart(2, '0') +
		'-' +
		String(today.getMinutes()).padStart(2, '0') +
		'-' +
		String(today.getSeconds()).padStart(2, '0');
	//Had to create a new workbook and then add the header
	const wb = XLSX.utils.book_new();
	const ws = XLSX.utils.json_to_sheet([]);
	// XLSX.WorkSheet = ws;
	XLSX.utils.sheet_add_aoa(ws, Heading);
	//Starting in the second row to avoid overriding and skipping headers
	XLSX.utils.sheet_add_json(ws, data, { origin: 'A2', skipHeader: true });

	// AutoFit columns
	const range = XLSX.utils.decode_range(ws['!ref']);
	for (let C = range.s.c; C <= range.e.c; ++C) {
		let longest = 0;
		for (let R = range.s.r; R <= range.e.r; ++R) {
			const cell = ws[XLSX.utils.encode_cell({ r: R, c: C })];
			if (cell && cell.v) {
				const cellLength = String(cell.v).length;
				if (cellLength > longest) {
					longest = cellLength;
				}
			}
		}
		ws['!cols'] = ws['!cols'] || [];
		ws['!cols'][C] = { width: longest * 1.2 };
	}

	XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
	XLSX.writeFile(wb, `${name}_${date}.xlsx`);
	store.dispatch(
		onResponse({
			isToaster: true,
			severity: commonVaribles.success,
			message: 'Records Download Successfully',
		})
	);
}

export function MasterDataSheet(data, name) {
	const wb = XLSX.utils.book_new();

	// Create a worksheet with headers
	const ws = XLSX.utils.aoa_to_sheet([
		['SHOP ID', 'SHOP NAME', 'LINE ID', 'LINE NAME'],
	]);

	// Initialize a row counter
	let row = 1;

	// Populate the worksheet with data from the object
	for (const shopId in data) {
		if (data.hasOwnProperty(shopId)) {
			const shopName = data[shopId].shop_name;
			const shopLines = data[shopId].lines;
			for (const lineId in shopLines) {
				if (shopLines.hasOwnProperty(lineId)) {
					const lineName = shopLines[lineId];
					XLSX.utils.sheet_add_aoa(ws, [[shopId, shopName, lineId, lineName]], {
						origin: row,
					});
					row++;
				}
			}
		}
	}

	var today = new Date();
	var date =
		String(today.getFullYear()).padStart(2, '0') +
		'-' +
		String(today.getMonth() + 1).padStart(2, '0') +
		'-' +
		String(today.getDate()).padStart(2, '0') +
		'_' +
		String(today.getHours()).padStart(2, '0') +
		'-' +
		String(today.getMinutes()).padStart(2, '0') +
		'-' +
		String(today.getSeconds()).padStart(2, '0');

	// AutoFit columns
	const range = XLSX.utils.decode_range(ws['!ref']);
	for (let C = range.s.c; C <= range.e.c; ++C) {
		let longest = 0;
		for (let R = range.s.r; R <= range.e.r; ++R) {
			const cell = ws[XLSX.utils.encode_cell({ r: R, c: C })];
			if (cell && cell.v) {
				const cellLength = String(cell.v).length;
				if (cellLength > longest) {
					longest = cellLength;
				}
			}
		}
		ws['!cols'] = ws['!cols'] || [];
		ws['!cols'][C] = { width: longest * 1.2 };
	}

	// Append the worksheet to the workbook
	XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

	// Generate and download the Excel file
	XLSX.writeFile(wb, `${name}_${date}.xlsx`);
}

export function sequenceStatusFormat(sequence) {
	switch (sequence) {
		case (sequence = 'approved'):
			return (
				<div className={clsx(globalstyle.status, globalstyle.complete)}> {UpperFirstLetter(sequence)} </div>
				// <div>{UpperFirstLetter(sequence)}</div>
			);
		case (sequence = 'inprogress'):
			return (
				<div className={clsx(globalstyle.status, globalstyle.progress)}> {UpperFirstLetter(sequence)} </div>
				// <div>{UpperFirstLetter(sequence)}</div>
			);
		case (sequence = 'pending'):
			return (
				<div className={clsx(globalstyle.status, globalstyle.pending)}> {UpperFirstLetter(sequence)} </div>
				// <div>{UpperFirstLetter(sequence)}</div>
			);
		case (sequence = 'rejected'):
			return (
				<div className={clsx(globalstyle.status, globalstyle.pending)}> {UpperFirstLetter(sequence)} </div>
				// <div>{UpperFirstLetter(sequence)}</div>
			);
		default:
			return (
				<div className={clsx(globalstyle.status, globalstyle.invalidstatus)}> - </div>
				// <div>-</div>
			);
	}
}

export function bomImgFormat(imglink) {
	const imgLinkPattern = /^.*\/([^/]+?)\?.*$/;
	if (imglink.length > 0 && imgLinkPattern.test(imglink)) {
		return (
			<div className={globalstyle.bomImgFormatStyle}>
				<img className={globalstyle.bomImgstyle} src={imglink} alt="part-img" />
			</div>
		);
	} else if (imglink === '') {
		return (
			<div className={globalstyle.bomImgFormatStyle}>
				<img
					className={globalstyle.bomImgstyle}
					src={defaultImg}
					alt="part-img"
				/>
			</div>
		);
	} else {
		return (
			<div className={globalstyle.bomImgFormatStyle}>
				<img
					className={globalstyle.bomImgstyle}
					src={defaultImg}
					alt="part-img"
				/>
			</div>
		);
	}
}

export const downloadData = (
	selectedRows,
	data,
	fileName,
	renamedHeaders,
	keyOrder
) => {
	const downloadData = [];

	data = reorderKeysInArrayOfObjects(data, keyOrder);

	if (data.length > 0) {
		data.forEach((dataItem, index) => {
			const newDataItem = {};
			Object.keys(dataItem).forEach((key) => {
				if (!excludeDownload.includes(key)) {
					const newKey = renamedHeaders[key] || key;
					let value = dataItem[key];
					if (Array.isArray(value)) {
						value = value.join(', ');
					} else if (isPlainObject(dataItem[key])) {
						value = dataItem[key]?.props?.rowData[key];
					} else if (dateColumns.includes(key)) {
						value =
							dataItem[key] === null ? '-' : convertUTCtoIST(dataItem[key]);
					}
					newDataItem[newKey] = value === null || '' ? '-' : value;
				}
			});
			if (selectedRows[index]) {
				downloadData.push(newDataItem);
			}
		});
		downloadBulk(downloadData, fileName);
	}
};

export const downloadDataForReport = (data, fileName, renamedHeaders) => {
	const downloadData = [];
	if (data.length > 0) {
		data.forEach((dataItem, index) => {
			const newDataItem = {};
			Object.keys(dataItem).forEach((key) => {
				if (!excludeDownload.includes(key)) {
					const newKey = renamedHeaders[key] || key;
					let value = dataItem[key];

					if (Array.isArray(value)) {
						value = value.join(', ');
					} else if (dateColumns.includes(key)) {
						value =
							dataItem[key] === null ? '-' : convertUTCtoIST(dataItem[key]);
					}
					newDataItem[newKey] = value === null ? '-' : value;
				}
			});
			if (data[index]) {
				downloadData.push(newDataItem);
			}
		});
		downloadBulk(downloadData, fileName);
	}
};

export const downloadBulkSearchTrolley = async function () {
	const csvdata = excelmaker(downloadExcelHeaderNameForTrolleyMaster);
	downloadTrolleyTemplate(csvdata);
};

export const excelmaker = function (data) {
	const ws = XLSX.utils.json_to_sheet([data], { header: Object.keys(data) });
	const wbBinaryString = XLSX.write(
		{ Sheets: { Sheet1: ws }, SheetNames: ['Sheet1'] },
		{ bookType: 'xlsx', bookSST: false, type: 'binary' }
	);
	const blob = new Blob([s2ab(wbBinaryString)], {
		type: 'application/octet-stream',
	});
	return blob;
};

export const downloadTrolleyTemplate = function (data) {
	const url = window.URL.createObjectURL(
		new Blob([data], {
			type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		})
	);
	const a = document.createElement('a');
	a.setAttribute('href', url);
	a.setAttribute('download', 'Bulk_Trolley_Template');
	a.click();
};

const pxToRem = (px, oneRemPx = 17) => `${px / oneRemPx}rem`;
const borderWidth = 2;
const width = pxToRem(35);
const height = pxToRem(22);
const size = pxToRem(11);
const gap = (34 - 22) / 2;

function formatTrolleyName(headers) {
	// Remove spaces, convert to lowercase, and add underscores between words
	if (headers === 'VC NO') {
		return 'vc_id';
	}
	return headers.replace(/\s+/g, '_').toLowerCase();
}

export const processData = (dataString) => {
	const dataStringLines = dataString.split(Regex.excelDataString);
	const headers = dataStringLines[0].split(Regex.excel);
	const formattedHeaderForRequestBody = headers.map(formatTrolleyName);
	const list = [];
	for (let i = 1; i < dataStringLines.length; i++) {
		const row = dataStringLines[i].split(Regex.excel);
		if (
			formattedHeaderForRequestBody &&
			row.length === formattedHeaderForRequestBody.length
		) {
			const obj = {};
			for (let j = 0; j < headers.length; j++) {
				let d = row[j];
				if (formattedHeaderForRequestBody[j]) {
					obj[formattedHeaderForRequestBody[j]] = d;
				}
			}
			// remove the blank rows
			if (Object.values(obj).filter((x) => x).length > 0) {
				list.push(obj);
			}
		}
	}
	return list;
};

export const handleFileUpload = (e, func) => {
	const file = e.target.files[0];
	const reader = new FileReader();
	reader.onload = (evt) => {
		const bstr = evt.target.result;
		const wb = XLSX.read(bstr, { type: 'binary' });
		const wsname = wb.SheetNames[0];
		const ws = wb.Sheets[wsname];
		const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
		const dataProcess = processData(data);
		func(dataProcess);
	};
	reader.readAsBinaryString(file);
};

const s2ab = (s) => {
	const buf = new ArrayBuffer(s.length);
	const view = new Uint8Array(buf);
	for (let i = 0; i < s.length; i++) {
		view[i] = s.charCodeAt(i) & 0xff;
	}
	return buf;
};

export const createFailedDataExcel = (failedData) => {
	const transformHeader = (key) => key.replace(/_/g, ' ').toUpperCase();
	const modifiedData = failedData.map((data) => {
		const modifiedEntry = {};
		for (const key in data) {
			modifiedEntry[transformHeader(key)] = data[key];
		}
		return modifiedEntry;
	});
	const ws = XLSX.utils.json_to_sheet(modifiedData);
	const wb = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(wb, ws, 'Failed_Data');
	const excelBlob = new Blob(
		[s2ab(XLSX.write(wb, { bookType: 'xlsx', type: 'binary' }))],
		{ type: 'application/octet-stream' }
	);
	return excelBlob;
};

export const CustomSwitch = styled(Switch)(({ theme }) => ({
	width,
	height,
	padding: 0,
	alignItems: 'center',
	margin: theme.spacing(1),
	overflow: 'unset',
	'&:active': {
		'& .MuiSwitch-thumb': {
			width: 15,
		},
		'& .MuiSwitch-switchBase.Mui-checked': {
			transform: 'translateX(8px)',
		},
		'& .MuiSwitch-track': {
			borderRadius: 40,
			border: `solid 2px #2162AC`,
			opacity: 1,
			backgroundColor: 'White',
			boxSizing: 'border-box',
		},
	},
	'& .MuiSwitch-switchBase': {
		padding: pxToRem(gap),
		'&.Mui-checked': {
			transform: 'translateX(12px)',
			color: '#fff',
			'& + .MuiSwitch-track': {
				opacity: 1,
				border: `solid 2px #2162AC`,
				backgroundColor: 'white',
			},
			'& .MuiSwitch-thumb': {
				backgroundColor: '#2162AC',
			},
		},
	},

	'& .MuiSwitch-thumb': {
		width: size,
		height: size,
		backgroundColor: '#707070',
		borderRadius: 6,
		transition: theme.transitions.create(['width'], {
			duration: 200,
		}),
	},
	'& .MuiSwitch-track': {
		borderRadius: 40,
		border: `solid 2px #707070`,
		opacity: 1,
		backgroundColor: 'White',
		boxSizing: 'border-box',
	},
}));

export const AlertsCustomSwitch = styled(Switch)(({ theme }) => ({
	width,
	height,
	padding: 0,
	alignItems: 'center',
	margin: theme.spacing(1),
	overflow: 'unset',
	'&:active': {
		'& .MuiSwitch-thumb': {
			width: 15,
		},
		'& .MuiSwitch-switchBase.Mui-checked': {
			transform: 'translateX(8px)',
		},
		'& .MuiSwitch-track': {
			borderRadius: 40,
			border: `solid 2px #2162AC`,
			opacity: 1,
			backgroundColor: 'White',
			boxSizing: 'border-box',
		},
	},
	'& .MuiSwitch-switchBase': {
		padding: pxToRem(gap),
		'&.Mui-checked': {
			transform: 'translateX(12px)',
			color: '#fff',
			'& + .MuiSwitch-track': {
				opacity: 1,
				border: `solid 2px #2162AC`,
				backgroundColor: 'white',
			},
			'& .MuiSwitch-thumb': {
				backgroundColor: '#2162AC',
			},
		},
	},

	'& .MuiSwitch-thumb': {
		width: size,
		height: size,
		backgroundColor: '#2162AC',
		borderRadius: 6,
		transition: theme.transitions.create(['width'], {
			duration: 200,
		}),
	},
	'& .MuiSwitch-track': {
		borderRadius: 40,
		border: `solid 2px #2162AC`,
		opacity: 1,
		backgroundColor: 'White',
		boxSizing: 'border-box',
	},
}));

export const replacingComma = (text) => {
	return text.replace(/,/g, ' * ');
}

export const replacingCommaToX = (text) => {
	return text.replace(/,/g, ' X ');
}

export const UpperFirstLetter = (word) => {
	const capitalized = word?.charAt(0)?.toUpperCase() + word?.slice(1);
	return capitalized;
};

export const IsUserRoleMatch = (userRoleName, userDetails) => {
	switch (userRoleName) {
		case 'scm_buyer':
			return userDetails?.user_role.some(
				(item) => item === 'PVBU_LOGISTICS_PACKAGING_SCM_BUYER_USER'
			);
		case 'logistics_buyer_user':
			return userDetails?.user_role.some(
				(item) => item === 'PVBU_LOGISTICS_PACKAGING_LOGISTICS_BUYER_USER'
			);
		case 'direct_material_buyer_user':
			return userDetails?.user_role.some(
				(item) => item === 'PVBU_LOGISTICS_PACKAGING_DIRECT_MATERIAL_BUYER_USER'
			);
		case 'supplier':
			return userDetails?.user_role.some(
				(item) => item === 'PVBU_LOGISTICS_PACKAGING_SUPPLIER_USER'
			);
		case 'admin':
			return userDetails?.user_role.some(
				(item) => item === 'PVBU_LOGISTICS_PACKAGING_ADMIN_USER'
			);
		default:
			return false;
	}
};

export const matchOption = (input, options) => {
	const match = options.find((option) => option?.value === input);
	return match || {};
};

const showUploadToast = (message, type) => {
	if (type === 'error') {
		toast.error(message, {
			position: toast.POSITION.BOTTOM_RIGHT,
		});
	} else {
		toast.success(message, {
			position: toast.POSITION.BOTTOM_RIGHT,
		});
	}
};

export const uploadExcelFile = (url, currentFile) => {
	if (url) {
		const blobFile = currentFile;
		const xhr = new XMLHttpRequest();
		xhr.open('PUT', url, true);
		xhr.setRequestHeader('Content-Type', blobFile.type);
		xhr.onload = function () {
			if (xhr.status != 200) {
				showUploadToast(
					`${commonVaribles.failed_to_upload_excel_sheet} ${currentFile.name}`,
					'error'
				);
			}
		};
		xhr.onerror = function () {
			showUploadToast(
				`${commonVaribles.failed_to_upload_excel_sheet} ${currentFile.name}`,
				'error'
			);
		};
		xhr.send(blobFile);
	} else {
		showUploadToast(
			`${commonVaribles.failed_to_upload_excel_sheet} ${currentFile.name}`,
			'error'
		);
	}
};
